import {
  tab_styles_default
} from "./chunk.C55PSA4P.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/tab/tab.styles.ts
var tab_styles_default2 = r` ${tab_styles_default} ${component_mobile_styles_default} .tab { font-weight: var(--sl-font-weight-normal); color: var(--sl-color-gray-950); } .tab--fluid { margin: 0 auto; } `;

export {
  tab_styles_default2 as tab_styles_default
};
